// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__18WAE","image":"App_image__2TKNy"};